import { api } from "./api";
import mapForecastResponse from "../Mappers/mapForecastResponse";

export async function fetchForecastData({
  accessToken,
  limit,
  offset,
  countryId,
  year,
  mktplaceId,
  ownerId,
  category,
  search,
  brand,
  kam,
}) {
  const res = await api.get("/GetForecastData", {
    params: {
      limit,
      offset,
      countryId,
      year,
      mktplaceId,
      cm_user_id: ownerId,
      category: category !== null ? category : undefined,
      sku: search !== "" ? search : undefined,
      brand: brand !== null ? brand : undefined,
      kam: kam !== null ? kam : undefined,
    },
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const data = mapForecastResponse(res?.data);

  return data;
}
